module.exports = __webpack_public_path__ + "img/miset4a.24a8c84e.jpg";